/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Form from "../../../components/Form";
import useForm from "../../../hooks/useForm";
import {
  postProducts,
  putProducts,
} from "../../../apis/companies/products";
import Modal, { ModalHeader } from "../../../components/Modal";
import systemAlert from "../../../utils/systemAlert";
import { isEmpty } from "lodash";
import { findModeLabel } from "../../../utils/mode";
import { cleanObj } from "../../../utils/cleanObj";

const defaultForm = {
  category: "",
  name: "",
  code: "",
  size: "",
  division: "",
  unit: "",
  buyPrice: "",
  sellPrice: "",
  memo: "",
  qty: ""
}

const ItemDetail = (props) => {
  const { selectedItem, setSelectedItem, open, setOpen, submit, permission } = props
  const [fields] = useState([
    [
      {
        title: "품목분류",
        key: "category",
        type: "input",
        required: true,
      },
      {
        title: "품목명",
        key: "name",
        type: "input",
        options: {
          placeholder: "품목명을 입력해주세요",
        },
        required: true,
      },
    ],
    [
      {
        title: "품목코드",
        key: "code",
        type: "input",
        options: {
          placeholder: "코드를 입력해주세요",
        },
        required: true,
      },
      {
        title: "규격",
        key: "size",
        type: "input",
        options: {
          placeholder: "규격을 입력해주세요",
        },
        required: true,
      },
    ],
    [
      {
        title: "구분",
        key: "division",
        type: "input",
        required: true,
      },
      {
        title: "단위",
        key: "unit",
        type: "input",
        required: true,
      },
    ],
    [
      {
        title: "매입단가",
        key: "buyPrice",
        type: "input",
        validators: ['comma'],
        required: true,
      },
      {
        title: "판매단가",
        key: "sellPrice",
        type: "input",
        validators: ['comma'],
        required: true,
      },
    ],
    [
      {
        title: '재고수량',
        key: 'qty',
        type: 'input',
        validators: ['comma'],
      }
    ],
    [
      {
        title: "메모",
        key: "memo",
        type: "textarea",
        options: {
          maxLength: 100,
        },
        required: false,
      },
    ],
  ]);
  const [mode, setMode] = useState('create')

  useEffect(() => {
    setValidateFields(fields)
    setMode(isEmpty(selectedItem) ? 'create' : (permission.level > 1 ? 'modify' : 'view'))
    if (selectedItem) {

      setForm(selectedItem)
      setOriginForm(selectedItem)
    } else {
      setForm(defaultForm);
      setOriginForm(defaultForm)
    }
  }, [open, selectedItem, permission]);

  const _submit = (form) => {
    cleanObj(form)
    if (mode === "create") {
      systemAlert(`"${form.name}" 품목을 등록하시겠습니까?`, {
        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '승인',
            onClick: () => {
              postProducts(form)
                .then(() => {
                  cancel();
                  if (submit) {
                    submit()
                  }
                })
            }
          }
        ]
      })
    } else {
      systemAlert(`"${form.name}" 품목을 수정하시겠습니까?`, {
        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '승인',
            onClick: () => {
              putProducts(selectedItem.idx, form)
                .then(() => {
                  cancel();
                  if (submit) {
                    submit()
                  }
                })
            }
          }
        ]
      })
    }
  };

  const {
    form,
    setForm,
    errors,
    handleOnChange,
    handleSubmit,
    setOriginForm,
    setValidateFields,
  } = useForm(
    defaultForm,
    _submit,
  );

  const cancel = (e) => {
    if (e) {
      e.preventDefault();
    }
    setOpen(false);
    setSelectedItem(null)
  };

  return (
    <Modal
      isOpen={open}
      close={cancel}
    >
      <div className="item-write">
        <ModalHeader>{selectedItem && <>"{selectedItem.name}"</>} 품목 {findModeLabel(mode)}</ModalHeader>
        <Form
          mode={permission.level > 1 ? "modify" : 'view'}
          form={form}
          errors={errors}
          isRequiredShow={true}
          setForm={setForm}
          fields={fields}
          onChange={handleOnChange}
          submitText={mode === 'create' ? '작성완료' : '수정'}
          submit={handleSubmit}
          cancel={cancel}
        />
      </div>
    </Modal>
  );
};

export default ItemDetail;
